import { render, staticRenderFns } from "./tradeManage.vue?vue&type=template&id=6c5b33d2&scoped=true"
import script from "./tradeManage.vue?vue&type=script&lang=js"
export * from "./tradeManage.vue?vue&type=script&lang=js"
import style0 from "./tradeManage.vue?vue&type=style&index=0&id=6c5b33d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5b33d2",
  null
  
)

export default component.exports